import LoginModal from '@/components/common/components/LoginModal'
import useAuthStore from '@/store/useAuthStore'
import Button from '@dgshahr/ui-kit/Button'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import heroImage from '~/public/assets/images/hero-section.png'

const highlights = [
  { value: '۵ دقیقه', label: 'ثبت‌نام سریع' },
  { value: '۲۴/۷', label: 'دسترسی پنل' },
  { value: '+۲۸٪', label: 'رشد فروش' }
]

function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const navigate = useNavigate()
  const { lastStep, accessToken } = useAuthStore()

  const stepRoutes: Record<number, string> = {
    1: '/merchant-register/category',
    2: '/merchant-register/address',
    3: '/merchant-register/document-upload',
    4: '/merchant-register/contract',
    5: '/merchant-register/status'
  }

  const openModal = () => {
    if (accessToken && lastStep) {
      const targetRoute = stepRoutes[lastStep as keyof typeof stepRoutes]
      if (targetRoute) navigate(targetRoute)
    } else {
      setIsModalOpen(true)
    }
  }

  const closeModal = () => setIsModalOpen(false)

  return (
    <section className="w-full bg-slate-50 py-6 tablet:py-10">
      <div className="mx-auto grid w-full max-w-[1280px] items-center gap-8 px-4 tablet:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:px-8">
        <div className="order-2 lg:order-1">
          <div className="mb-4 inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-600">
            همکاری با آپولون
          </div>

          <h1 className="text-[28px] font-black leading-tight text-slate-900 tablet:text-[38px] tablet:leading-[1.2]">
            فروشنده شوید و
            <span className="block text-primary-600">بیشتر بفروشید!</span>
          </h1>

          <p className="mt-4 max-w-xl text-base leading-8 text-slate-600 tablet:text-lg">
            مشتریان با اعتبار آپولون می‌توانند راحت‌تر از فروشگاه شما خرید کنند و
            تجربه‌ای سریع‌تر و مطمئن‌تر در خرید داشته باشند.
          </p>

          <div className="mt-8 flex flex-col items-start gap-4 sm:flex-row sm:items-center">
            <Button
              onClick={openModal}
              className="flex min-w-[180px] items-center !bg-primary-500 justify-center rounded-xl px-6 py-3 text-base font-semibold shadow-sm transition hover:shadow-md"
            >
              {accessToken && lastStep ? 'ورود' : 'ثبت‌نام / ورود'}
            </Button>

            <a
              href="#process"
              className="text-sm font-semibold text-slate-700 transition hover:text-primary-600"
            >
              مشاهده فرآیند همکاری
            </a>
          </div>

          <div className="mt-8 grid gap-4 grid-cols-3 text-center mobile:grid-cols-3">
            {highlights.map((item) => (
              <div
                key={item.label}
                className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
              >
                <div className="text-xl font-black text-slate-900">{item.value}</div>
                <div className="mt-1 text-xs text-slate-500">{item.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="relative overflow-hidden rounded-[32px] border border-slate-200 bg-gradient-to-br from-primary-200 via-white to-slate-100 p-4 shadow-[0_24px_60px_rgba(15,23,42,0.08)]">
            <div className="absolute inset-x-10 top-0 h-32 rounded-full bg-primary-200/60 blur-3xl" />
            <div className="relative overflow-hidden rounded-[24px] bg-white/50 p-3 backdrop-blur-sm">
              <img
                src={heroImage}
                alt="merchant growth"
                className="h-[320px] w-full rounded-[20px] object-cover tablet:h-[420px]"
              />
            </div>

            <div className="absolute bottom-8 left-8 rounded-2xl bg-white/90 px-4 py-3 shadow-lg backdrop-blur-sm">
              <div className="text-[10px] font-medium text-slate-500">درآمد ماهانه</div>
              <div className="mt-1 text-lg font-black text-slate-900">+۳۲٪</div>
            </div>
          </div>
        </div>
      </div>

      <LoginModal isOpen={isModalOpen} onClose={closeModal} />
    </section>
  )
}

export default HeroSection
